'use strict';

const processInclude = require('base/util');
const { queryFirst } = require('./domUtil');

document.addEventListener('DOMContentLoaded', () => {
    processInclude(require('./storeLocator/storeLocator'));
    const isGoogleAutoCompleteEnable = queryFirst('#enableGoogleAutoComplete');

    if (isGoogleAutoCompleteEnable && isGoogleAutoCompleteEnable.value) {
        processInclude(require('./googleAddressSuggestion'));
    }
});
